import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";
import { TableIdentifier } from "../../tableData/types";

export type State = TableIdentifier["idWithinKind"][];

const initialState: State = [];

const idsOfTablesFetchingFiltersReducer = reducer(
  initialState,
  on(AC.userFilterGetFiltersForTableRequest, (state, { payload }) => {
    const { idWithinKind } = payload.identifier;

    return [...state, idWithinKind];
  }),
  on(
    AC.userFilterGetFiltersForTableSuccess,
    AC.userFilterGetFiltersForTableError,
    (state, { payload }) =>
      state.filter((id) => id !== payload.identifier.idWithinKind)
  )
);

export default idsOfTablesFetchingFiltersReducer;
export type IdsOfTemplatesFetchingFilters = State;
